import {filter} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {Step} from '../application-flow/steps/step';
import {NavigationStart, Router} from '@angular/router';
import {LoanApplicationFlowSteps} from '../application-flow/steps/loan-application-flow.steps';
import {Location} from "@angular/common";

@Component({
    styleUrls: ['./left-div.component.css'],
    templateUrl: './left-div.component.html',
    selector: 'app-loan-application-left-div'
})
export class LeftDivComponent implements OnInit {
    public readonly applicationFlowSteps: LoanApplicationFlowSteps;
    public readonly stepStatus: Map<Step, StepStatus> = new Map<Step, StepStatus>();
    private location: Location;

    constructor(location: Location, loanApplicationFlowSteps: LoanApplicationFlowSteps, router: Router) {
        this.applicationFlowSteps = loanApplicationFlowSteps;
        this.location = location;
        router.events.pipe(filter(event => event instanceof NavigationStart))
            .subscribe(() => this.updateStatusOfSteps());
    }

    async ngOnInit(): Promise<void> {
        await this.updateStatusOfSteps();
    }

    private async updateStatusOfSteps() {
        const isStepComplete = new Map<Step, boolean>();
        for (const step of this.applicationFlowSteps) {
            const isComplete = await step.isComplete();
            if (!isComplete) {
                const isStepInProgress = Array.from(isStepComplete.values()).every(v => v);
                const stepStatus = isStepInProgress ? StepStatus.InProgress : StepStatus.Pending;
                this.stepStatus.set(step, stepStatus);
            } else {
                this.stepStatus.set(step, StepStatus.Completed);
            }
            isStepComplete.set(step, isComplete);
        }
    }
    
    isFirstPage(): boolean {
        return this.location.path().endsWith('intro');
    }
}

enum StepStatus {
    Pending = 'pending',
    Completed = 'completed',
    InProgress = 'in-progress'
}